export default "__VITE_ASSET__H4rRaPih__"